import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'loyerInput',
    'chargesInput',
    'honorairesInput',
    'fraisInput',
    'totalToDeductInput',
    'toDeductFromDgInput',
    'toDeductFromFraisInput',
    'toRefundtoTenantInput',
    'refundBtn',
    'ibanBtn',
    'ibanWarning',
  ];

  static values = {
    dg: Number,
    creditLoc: Number,
    creditAvoirs: Number,
    loyer: Number,
    charges: Number,
    honoraires: Number,
    frais: Number,
    iban: String,
  };

  connect() {
    this.updateTotalWithValues();
  }

  autoFillAmounts() {
    this.loyerInputTarget.value = this.loyerValue;
    this.chargesInputTarget.value = this.chargesValue;
    this.honorairesInputTarget.value = this.honorairesValue;
    this.fraisInputTarget.value = this.fraisValue;
    this.updateTotalWithValues();
  }

  updateTotalWithValues() {
    const montantDg = parseFloat(this.dgValue);
    const montantCreditLoc = parseFloat(this.creditLocValue);
    const montantCreditAvoirs = parseFloat(this.creditAvoirsValue);
    const inputs = [this.loyerInputTarget, this.chargesInputTarget, this.honorairesInputTarget, this.fraisInputTarget];
    let totalToDeduct = 0;
    inputs.forEach(inputElem => {
      let inputValue = parseFloat(inputElem.value);
      if (isNaN(inputValue))
        inputValue = 0.0;
      totalToDeduct += inputValue;
    });
    const sumCredit = montantDg + montantCreditLoc + montantCreditAvoirs;
    const toDeductFromDg = Math.min(sumCredit, totalToDeduct);
    const toDeductFromFrais = totalToDeduct - toDeductFromDg;
    const toRefundToTenant = sumCredit - totalToDeduct;
    this.totalToDeductInputTarget.value = totalToDeduct.toFixed(2);
    this.toDeductFromDgInputTarget.value = toDeductFromDg.toFixed(2);
    this.toDeductFromFraisInputTarget.value = toDeductFromFrais.toFixed(2);
    this.toRefundtoTenantInputTarget.textContent = toRefundToTenant.toFixed(2);

    // Gestion du bouton prélever/rembourser et de l'alerte IBAN manquant selon les valeurs
    if (toRefundToTenant >= 0) {
      if (this.ibanValue == "") {
        if (!this.refundBtnTarget.classList.contains('hidden')) {
          this.refundBtnTarget.classList.add('hidden');
          this.refundBtnTarget.disabled = true;
        }
        this.ibanBtnTarget.classList.remove('hidden');
        this.ibanWarningTarget.classList.remove('hidden');
      } else {
        this.refundBtnTarget.classList.remove('hidden');
        this.refundBtnTarget.disabled = false;
        this.refundBtnTarget.querySelector('.btn__label').textContent = "Rembourser";
        if (!this.ibanBtnTarget.classList.contains('hidden'))
          this.ibanBtnTarget.classList.add('hidden');
        if (!this.ibanWarningTarget.classList.contains('hidden'))
          this.ibanWarningTarget.classList.add('hidden');
      }
    } else {
      this.refundBtnTarget.classList.remove('hidden');
      this.refundBtnTarget.disabled = false;
      this.refundBtnTarget.querySelector('.btn__label').textContent = "Prélever";
      if (!this.ibanBtnTarget.classList.contains('hidden'))
        this.ibanBtnTarget.classList.add('hidden');
      if (!this.ibanWarningTarget.classList.contains('hidden'))
        this.ibanWarningTarget.classList.add('hidden');
    }
  }
}
